/* global imagesLoaded, Isotope: false */
export default class IsotopeFilters {
    constructor(el) {
        if (!el) return;
        this.el = el;
        this.init();
		this.events();
    }

    init() {
        if (this.el.dataset.isotope) {
            this.iso = new Isotope(this.el, JSON.parse(this.el.dataset.isotope));
            imagesLoaded(this.el).on('progress', () => {
				this.iso.layout();
			});
		}
    }

	events() {
		window.addEventListener('resize', () => {
			this.iso.layout();
		}, true);

		document.querySelectorAll('.isotope-filters button').forEach(el => {
			el.addEventListener('click', ev => {
				this.iso.arrange({
					filter: ev.currentTarget.dataset.filter
				});
			}, false);
		});
	}
}

Array.from(document.querySelectorAll('[data-isotope]')).map(el => new IsotopeFilters(el));
